module.exports = __webpack_public_path__ + "media/images/black_history_month/belly_full-7062d18af18026315fc862f835db7b6f.png";